import { createSelector } from '@reduxjs/toolkit'
import { RootState } from './configure-store'

export const getStore = (state: RootState) => state.loaderLuminar

export const getLoaderLuminar = createSelector(getStore, state => state.showLoaderLuminar)
export const getTimeAnimationLoaderLuminarProd = createSelector(getStore, state => state.timeAnimationLoaderLuminarProd)
export const getTimeAnimationLoaderLuminarDev = createSelector(getStore, state => state.timeAnimationLoaderLuminarDev)
